// extracted by mini-css-extract-plugin
module.exports = {"link":"SocialMedia_link__7Na1J","withIcon":"SocialMedia_withIcon__2Czgo","label":"SocialMedia_label__Qz4kO"};